var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('background-view',{attrs:{"message":_vm.message,"is-processing":_vm.isProcessing}},[_c('requested-document-processor',{ref:"processor",attrs:{"validator":_vm.validator,"shouldApplyValueForcibly":_vm.shouldApplyValueForcibly}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }